import { render, staticRenderFns } from "./MicrolearningStatus.vue?vue&type=template&id=3855dad2&scoped=true"
import script from "./MicrolearningStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningStatus.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningStatus.vue?vue&type=style&index=0&id=3855dad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3855dad2",
  null
  
)

export default component.exports